import React from 'react';
import classNames from 'classnames';
import { Check, ArrowRight, Building2 } from 'lucide-react';

import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import { landingSectionSurfaceClassName } from '../../../LandingPage/landingSectionSurface';
import SectionContainer from '../SectionContainer';
import css from './SectionSpaceOwner.module.css';
import spaceOwnerImg from './space-owner-cta.jpg';

const BENEFIT_KEYS = [
  'SectionSpaceOwner.benefit1',
  'SectionSpaceOwner.benefit2',
  'SectionSpaceOwner.benefit3',
];

/**
 * Space-owner acquisition section, styled as a full-bleed image banner that
 * mirrors SectionLoungeBreaker (eyebrow pill, bold title, subtitle, 3 benefit
 * checkmarks, white pill CTA → the space-owner landing page).
 */
const SectionSpaceOwner = props => {
  const { sectionId, className, rootClassName, appearance, options, landingSurface } = props;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={classNames(rootClassName, landingSectionSurfaceClassName(landingSurface))}
      appearance={appearance}
      options={options}
    >
      <div className={css.inner}>
        <div className={css.banner}>
          <img
            className={css.bannerImg}
            src={spaceOwnerImg}
            alt=""
            loading="lazy"
            decoding="async"
            width="800"
            height="449"
          />
          <span className={css.scrim} aria-hidden="true" />
          <div className={css.content}>
            <span className={css.eyebrow}>
              <Building2 size={16} strokeWidth={2} aria-hidden="true" />
              <FormattedMessage id="SectionSpaceOwner.eyebrow" />
            </span>
            <h2 className={css.title}>
              <FormattedMessage id="SectionSpaceOwner.title" />
            </h2>
            <p className={css.subtitle}>
              <FormattedMessage id="SectionSpaceOwner.description" />
            </p>
            <ul className={css.benefits}>
              {BENEFIT_KEYS.map(id => (
                <li key={id} className={css.benefit}>
                  <Check
                    className={css.benefitIcon}
                    size={18}
                    strokeWidth={2.5}
                    aria-hidden="true"
                  />
                  <FormattedMessage id={id} />
                </li>
              ))}
            </ul>
            <NamedLink name="SpaceOwnerLandingPage" className={css.cta}>
              <FormattedMessage id="SectionSpaceOwner.ctaButton" />
              <ArrowRight size={18} strokeWidth={2.25} aria-hidden="true" />
            </NamedLink>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default SectionSpaceOwner;
